'use client';

import {
  Box,
  Divider,
  IconButton,
  SystemIcon,
  Typography,
} from '@wishket/design-system';

interface MobileTitleBoxProps {
  title: string;
  bottomDivider?: boolean;
  openUserMenu?: () => void;
  onBackButtonClick?: () => void;
}

const MobileTitleBox = ({
  title,
  bottomDivider,
  openUserMenu,
  onBackButtonClick,
}: MobileTitleBoxProps) => {
  return (
    <Box className="desktop:hidden">
      <Box className="flex h-[60px] items-center justify-between px-5">
        <IconButton size="sm" onClick={onBackButtonClick}>
          <SystemIcon name="large_arrow_left" />
        </IconButton>
        <Box className="flex flex-1 items-center justify-center">
          <Typography variant="subTitle1" className="line-clamp-1 ">
            {title}
          </Typography>
        </Box>
        <IconButton size="sm" onClick={openUserMenu}>
          <SystemIcon name="large_drawer" />
        </IconButton>
      </Box>
      {bottomDivider && <Divider />}
    </Box>
  );
};

export default MobileTitleBox;
